import { Component, OnInit, Output, EventEmitter, OnDestroy, ViewEncapsulation } from "@angular/core";
import { MainService } from "../Services/service.service";
import { timer, Subscription } from "rxjs";
import { ConversationService } from "../Services/conversationService";
import { MatDialog } from "@angular/material";
import { TokenExpiredDialogComponent } from "../Dialogs/token-expired-dialog/token-expired-dialog.component";
import { DeleteAccountDialog } from "../Dialogs/delete-account-dialog/delete-account-dialog.component";

@Component({
  selector: "app-nav",
  templateUrl: "./app-nav.component.html",
  styleUrls: ["./app-nav.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AppNavComponent implements OnInit, OnDestroy {
  @Output() onLogout: EventEmitter<any> = new EventEmitter();
  public enableSubscription:boolean = false;

  constructor(public mainService: MainService, private conversationService: ConversationService, public dialog: MatDialog) { 
    this.enableSubscription = mainService.enableSubscription;
  }

  newMessageCount: number = 0;

  private checkMessageSubscription: Subscription;
  private tokenExpirationSubscription: Subscription;

  ngOnInit() {
    this.checkMessageSubscription = timer(1000, 5000).subscribe(() => {
      this.conversationService.getUnreadedMessageCount().then((unreadedMessages) => {
        if (this.newMessageCount != unreadedMessages) {
          this.newMessageCount = 0;
          setTimeout(() => {
            this.newMessageCount = unreadedMessages;
          }, 50);

        }
        
      });
    });
    this.tokenExpirationSubscription = timer(0, 1000).subscribe(() => {
      if (this.mainService.userService.isTokenExist() && this.mainService.userService.isTokenExpired()) {
        this.tokenExpirationSubscription.unsubscribe();
        const dialogRef = this.dialog.open(TokenExpiredDialogComponent, {
          autoFocus: true,
          hasBackdrop: true,
          disableClose: true,
          data: {},
        });
        dialogRef.afterClosed().subscribe(() => {
          this.logout();
        });
        

      }
    });
  }

  ngOnDestroy() {
    this.checkMessageSubscription.unsubscribe();
    this.tokenExpirationSubscription.unsubscribe();
  }


  logout() {
    this.mainService.userService.logout();
    this.mainService.showThxLogoutDialog();
    this.onLogout.emit(null);
  }


  get isPremium(): boolean {
    return this.mainService.userService.isPremium();
  }

  get ShowSpecialBadge(): boolean {
    return this.isPremium || this.isDemo;
  }


  get showUpgradeToPremiumLine(): boolean {
    if (!this.mainService.userService.isAuthenticated()) {
      return true;
    }

    return !(this.mainService.userService.isPremium() || this.mainService.userService.isAdmin() || this.mainService.userService.isDemo())
  }

  showAllNonDemoAds() {
    this.mainService.advService.searchDataStandard.currentSearchRule.nonDemoOnly = true;
    this.mainService.advService.searchDataStandard.currentSearchRule.casualDating = null;
    this.mainService.advService.searchDataStandard.currentSearchRule.pageNumber = 0;
    this.mainService.advService.searchAction(true, "search-results");
  }

  get isDemo(): boolean {
    return this.mainService.userService.isDemo()
  }

  get isAdminOrDemo() {
    return this.mainService.userService.isDemo() || this.mainService.userService.isAdmin();
  }

  showDeleteAccountModal() {
    const dialogRef = this.dialog.open(DeleteAccountDialog, {
      autoFocus: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    });
  }
}
